import { render, staticRenderFns } from "./StatementsMailCompleteModal.vue?vue&type=template&id=1c0a05ae&"
import script from "./StatementsMailCompleteModal.vue?vue&type=script&lang=ts&"
export * from "./StatementsMailCompleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./StatementsMailCompleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports